import { ChakraProps } from "@chakra-ui/react";
import { BgHome } from "../../common/assets/images";
import { StringOrNumber } from "../../types";

export const getHoverActiveFocusStyles = (props: ChakraProps) => ({
  _hover: props,
  _active: props,
  _focus: props,
});

export const getGapStyles = (gap: StringOrNumber | { [key: string]: StringOrNumber }, column = false) => ({
  sx: { "& > *:not(:last-child)": column ? { mb: gap } : { mr: gap } },
});

export const bgStyles = {
  bgImage: BgHome,
  bgRepeat: "no-repeat",
  bgPos: "left",
  bgSize: { base: "125%", sm: "100%", lg: "50%" },
};
